import { Routes, Route } from 'react-router-dom';
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";

// Pages
import Index from '@/pages/Index';
import Auth from '@/pages/Auth';
import Dashboard from '@/pages/Dashboard';
import Clientes from '@/pages/Clientes';
import ClienteDetalhe from '@/pages/ClienteDetalhe';
import ReguaCobranca from '@/pages/ReguaCobranca';
import ReguaDetalhe from '@/pages/ReguaDetalhe';
import Configuracoes from '@/pages/Configuracoes';
import Usuarios from '@/pages/Usuarios';
import Faturas from '@/pages/Faturas';
import FaturaDetalhe from '@/pages/FaturaDetalhe';
import PaymentPage from '@/pages/PaymentPage';
import Sucesso from '@/pages/Sucesso';
import ResetPassword from '@/pages/ResetPassword';
import NotFound from '@/pages/NotFound';

// Components
import { ProtectedRoute } from '@/components/auth/ProtectedRoute';
import { AdminLayout } from '@/components/layout/AdminLayout';

function App() {
  return (
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Index />} />
        <Route path="/auth" element={<Auth />} />
        <Route path="/checkout/:invoiceId" element={<PaymentPage />} />
        <Route path="/pay/:linkToken" element={<PaymentPage />} />
        <Route path="/sucesso" element={<Sucesso />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<AdminLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/clientes" element={<Clientes />} />
            <Route path="/clientes/:id" element={<ClienteDetalhe />} />
            <Route path="/faturas" element={<Faturas />} />
            <Route path="/faturas/:id" element={<FaturaDetalhe />} />
            <Route path="/regua" element={<ReguaCobranca />} />
            <Route path="/regua/:id" element={<ReguaDetalhe />} />
            <Route path="/configuracoes" element={<Configuracoes />} />
            <Route path="/usuarios" element={<Usuarios />} />
          </Route>
        </Route>

        {/* 404 */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </TooltipProvider>
  );
}

export default App;
